export default {
    product: {
        description: {
            more: "mais"
        },
        added: "Adicionado ao carrinho"
    }
}